// Checklists de inspección diaria, uno por instalación (canopy, Tarzan Swing, Canyoning).
// Única fuente para el render del asistente y los labels de las demás pantallas.
//
// ITEMS, ITEM_KEYS, SECCIONES y LABEL_TO_KEY siguen siendo los de canopy (las
// pantallas administrativas y el PDF los usan así). Para otra instalación:
// getChecklist(instalacion).

export const ESTADOS = ['aprobado', 'alerta', 'falla'];

const seccionesDe = (defs, items) =>
  defs.map(([id, titulo]) => ({ id, titulo, items: items.filter((i) => i.seccion === id) }));

// ── Canopy: "Inspección diaria de canopy" (copiado 1:1 de MaintainX) ─────────
export const ITEMS = [
  // Sección Plataformas
  { key: 'anclajes_pernos',            label: 'Anclajes y pernos',              descripcion: 'Revisar que estén correctamente colocados y ajustados.', seccion: 'plataformas' },
  { key: 'anclajes_arbol_plataforma',  label: 'Anclajes del árbol y plataforma', descripcion: 'Revisar los anclajes del árbol y la plataforma.',       seccion: 'plataformas' },
  { key: 'colchonetas',                label: 'Colchonetas de seguridad',       descripcion: 'Revisar que estén en su lugar y ajustadas.',            seccion: 'plataformas' },
  { key: 'linea_seguridad',            label: 'Línea de seguridad',             descripcion: 'Revisar anclajes de la línea de seguridad.',            seccion: 'plataformas' },
  { key: 'freno_seguridad',            label: 'Freno de seguridad',             descripcion: 'Revisar la integridad del mecanismo de freno; cuerda, polea y mosquetones.', seccion: 'plataformas' },
  { key: 'estado_fitosanitario',       label: 'Estado fitosanitario del árbol', descripcion: 'Revisar la salud general del árbol, anotar cualquier anomalía.', seccion: 'plataformas' },
  { key: 'equipo_adicional',           label: 'Equipo adicional en plataformas', descripcion: 'Revisar estado de la plataforma, de la madera y las líneas de anclaje.', seccion: 'plataformas' },
  { key: 'piso',                       label: 'Piso',                           descripcion: 'Revisar que el piso esté bien, reportar cualquier deterioro.', seccion: 'plataformas' },
  // Sección Cables
  { key: 'punto_anclaje',              label: 'Punto de anclaje',               descripcion: 'Revisar que los puntos de anclaje del cable estén en buen estado.', seccion: 'cables' },
  { key: 'estado_cable',               label: 'Estado del cable',               descripcion: 'Revisar el estado general del cable.',                  seccion: 'cables' },
];

export const ITEM_KEYS = ITEMS.map((i) => i.key);

export const SECCIONES = seccionesDe([['plataformas', 'Plataformas'], ['cables', 'Cables']], ITEMS);

// Mapa label→key para el parser del import histórico (MaintainX usa labels).
export const LABEL_TO_KEY = Object.fromEntries(ITEMS.map((i) => [i.label, i.key]));

// ── Tarzan Swing ──────────────────────────────────────────────────────────────
// Propuesta estándar (docs/superpowers/specs/2026-10-14-tarzan-swing-checklist-
// propuesta.md), EN VALIDACIÓN con el inspector. Mientras TARZAN_PENDIENTE sea
// true, el asistente lo muestra deshabilitado ("Checklist en validación") y no
// deja empezar una inspección del Tarzan; la base también la rechaza.
// Para activarlo: migración con las claves finales y esta constante en false.
export const TARZAN_PENDIENTE = true;

const ITEMS_TARZAN = [
  { key: 'anclaje_superior',       label: 'Anclaje superior y suspensión',     descripcion: 'Pernos, placas y grilletes sin juego, deformación ni corrosión; pasadores asegurados.', seccion: 'estructura' },
  { key: 'estructura_soporte',     label: 'Árbol o estructura de soporte',     descripcion: 'Estado fitosanitario o estructural: sin grietas, pudrición, ramas muertas sobre la zona ni inclinación nueva.', seccion: 'estructura' },
  { key: 'cuerda_principal',       label: 'Cuerda o cable principal',          descripcion: 'Sin cortes, abrasión, hilos rotos ni deformación; terminales, guardacabos y costuras en buen estado.', seccion: 'oscilacion' },
  { key: 'conectores_giratorio',   label: 'Conectores, giratorio y poleas',    descripcion: 'Mosquetones con cierre y bloqueo, giratorio (swivel) y poleas giran libres y sin desgaste.', seccion: 'oscilacion' },
  { key: 'sistema_liberacion',     label: 'Sistema de liberación',             descripcion: 'Prueba de disparo sin carga correcta; seguro contra disparo accidental en su lugar.', seccion: 'oscilacion' },
  { key: 'linea_izado',            label: 'Línea de izado y malacate',         descripcion: 'Cuerda de izado, anclaje, freno o trinquete del malacate funcionando.', seccion: 'oscilacion' },
  { key: 'arneses_asiento',        label: 'Arneses o asiento',                 descripcion: 'Costuras, hebillas y reguladores sin daño; tallas disponibles.', seccion: 'participante' },
  { key: 'plataforma_lanzamiento', label: 'Plataforma o punto de lanzamiento', descripcion: 'Piso, barandas y línea de vida del operador en buen estado.', seccion: 'zona' },
  { key: 'zona_oscilacion',        label: 'Zona de oscilación',                descripcion: 'Libre de obstáculos y vegetación; área de seguridad señalizada; acceso de rescate despejado.', seccion: 'zona' },
  { key: 'prueba_lastre',          label: 'Prueba antes de operar',            descripcion: 'Recorrido completo en vacío o con lastre, sin roces ni ruidos anormales.', seccion: 'zona' },
];

// ── Canyoning ─────────────────────────────────────────────────────────────────
// Borrador de arranque aprobado por Isaac el 2026-10-19; se afina con el
// operador. Activo (no pendiente), a diferencia del Tarzan.
export const CANYONING_PENDIENTE = false;

const ITEMS_CANYONING = [
  { key: 'cuerdas_rapel',          label: 'Cuerdas de rapel por descenso',         descripcion: 'Sin cortes, abrasión, núcleo expuesto, quemaduras ni abultamientos; fecha de compra y vida útil vigentes.', seccion: 'anclajes' },
  { key: 'anclajes_reuniones',     label: 'Anclajes y reuniones por descenso',     descripcion: 'Cable, lazos, cordinos y chapas sin corrosión ni deformación; fijación a la roca firme; revisar también después de crecidas.', seccion: 'anclajes' },
  { key: 'mosquetones_conectores', label: 'Mosquetones y conectores',              descripcion: 'Cierre y bloqueo funcionando, sin grietas, rebabas ni desgaste en el punto de apoyo.', seccion: 'anclajes' },
  { key: 'arneses',                label: 'Arneses',                               descripcion: 'Costuras, hebillas y cintas sin daño; tallas disponibles.', seccion: 'equipo' },
  { key: 'cascos',                 label: 'Cascos',                                descripcion: 'Sin golpes ni grietas; ajuste y barbiquejo en buen estado.', seccion: 'equipo' },
  { key: 'descensores_ocho',       label: 'Descensores y ocho de rescate',         descripcion: 'Sin desgaste ni filos; cuerda corre sin atascos.', seccion: 'equipo' },
  { key: 'equipo_rescate',         label: 'Equipo de rescate vertical completo',   descripcion: 'Cuerdas de rescate, prusiks, camilla o férula y botiquín completos y a mano.', seccion: 'equipo' },
  { key: 'acceso_pozas',           label: 'Escalera o sendero de acceso y pozas',  descripcion: 'Escalera y pasamanos firmes; sendero despejado; pozas sin obstáculos nuevos.', seccion: 'ruta' },
  { key: 'caudal_clima',           label: 'Caudal y clima del día',                descripcion: 'Caudal y clima aptos para operar (sin crecida ni lluvia fuerte aguas arriba).', seccion: 'ruta' },
];

// ── Mapa por instalación (el orden es el de la pantalla de elegir) ───────────
const armar = (id, nombre, items, secciones, pendiente) => ({
  id, nombre, items, itemKeys: items === ITEMS ? ITEM_KEYS : items.map((i) => i.key), secciones, pendiente,
});

export const INSTALACIONES = {
  canopy: armar('canopy', 'Canopy', ITEMS, SECCIONES, false),
  tarzan_swing: armar(
    'tarzan_swing',
    'Tarzan Swing',
    ITEMS_TARZAN,
    seccionesDe([
      ['estructura', 'Estructura y anclajes'],
      ['oscilacion', 'Sistema de oscilación'],
      ['participante', 'Equipo del participante'],
      ['zona', 'Operación y zona'],
    ], ITEMS_TARZAN),
    TARZAN_PENDIENTE,
  ),
  canyoning: armar(
    'canyoning',
    'Canyoning',
    ITEMS_CANYONING,
    seccionesDe([
      ['anclajes', 'Anclajes y cuerdas'],
      ['equipo', 'Equipo del participante y rescate'],
      ['ruta', 'Ruta y condiciones'],
    ], ITEMS_CANYONING),
    CANYONING_PENDIENTE,
  ),
};

export const INSTALACION_DEFAULT = 'canopy';

// { id, nombre, items, itemKeys, secciones, pendiente } o null si no existe.
export const getChecklist = (instalacion, mapa = INSTALACIONES) =>
  (instalacion && Object.prototype.hasOwnProperty.call(mapa, instalacion) ? mapa[instalacion] : null);

// Instalaciones que ya se pueden inspeccionar (con ítems y sin marca pendiente).
export const instalacionesConChecklist = (mapa = INSTALACIONES) =>
  Object.values(mapa).filter((c) => !c.pendiente && c.items.length > 0);
